var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPearsonMobilelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8347 0.82373H1.74957L1.7467 27.1767H6.31865L6.32224 17.6815H10.8347C16.1499 17.6815 19.7055 14.07 19.7055 9.25261C19.7055 4.4352 16.1499 0.82373 10.8347 0.82373ZM10.2606 13.3916H6.32224V5.11363H10.2606C13.3962 5.11363 15.0411 6.7695 15.0411 9.25261C15.0411 11.7357 13.3962 13.3916 10.2606 13.3916Z",
    fill: "#0D004D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5753 2.6178V2.62062C22.5753 2.62062 22.9 5.06776 22.9 9.24341C22.9 13.4191 22.5753 15.869 22.5753 15.8662V15.869C24.2352 14.1356 25.2537 11.8069 25.2537 9.24412V9.2427C25.2537 6.68061 24.2352 4.35195 22.5753 2.6178Z",
    fill: "#0D004D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6339 7.00362C22.2863 5.70882 21.6333 4.48877 20.731 3.38016C19.9562 2.52401 19.0166 1.77718 17.9508 1.17139C18.9843 2.7786 19.6795 5.78428 19.6795 9.2279C19.6795 12.6715 18.9858 15.6702 17.9544 17.2788C17.9465 17.2971 17.9386 17.3155 17.93 17.3331C18.5242 16.9967 19.0797 16.6166 19.5892 16.1977C21.3481 14.551 22.5049 12.5742 22.8295 10.4247C22.8761 10.041 22.9005 9.65104 22.9005 9.25541C22.9005 8.47966 22.808 7.72647 22.6339 7.00362Z",
    fill: "#0D004D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPearsonMobilelogo);
export default __webpack_public_path__ + "static/media/Pearson-mobilelogo.3d6e87812031bd987138250f3af5d300.svg";
export { ForwardRef as ReactComponent };